/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentFlag } from "./ShipmentFlag";
import {
  ShipmentFlagFromJSON,
  ShipmentFlagFromJSONTyped,
  ShipmentFlagToJSON,
  ShipmentFlagToJSONTyped,
} from "./ShipmentFlag";
import type { OperationalIssue } from "./OperationalIssue";
import {
  OperationalIssueFromJSON,
  OperationalIssueFromJSONTyped,
  OperationalIssueToJSON,
  OperationalIssueToJSONTyped,
} from "./OperationalIssue";

/**
 *
 * @export
 * @interface ShipmentDetail
 */
export interface ShipmentDetail {
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  proNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  billOfLadingNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  carrierPickupNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  serviceIdentifier?: string;
  /**
   * The carrier's own name for the service, e.g. "Maxximum Express". Absent when the shipment was quoted by email, since the carrier may have quoted a different product than we asked about.
   * @type {string}
   * @memberof ShipmentDetail
   */
  carrierServiceName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  pickupBusinessName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  pickup?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  pickupDate?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  deliveryBusinessName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  delivery?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  deliveryDate?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  commodity?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentDetail
   */
  handlingUnits?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentDetail
   */
  weightLbs?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  freightClass?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentDetail
   */
  quotedTransitDays?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentDetail
   */
  actualTransitDays?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentDetail
   */
  paidCad?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentDetail
   */
  bookedAt?: string;
  /**
   * The open operational issues on this shipment. They render as banners
   * at the top of the shipment page carrying their response action — the
   * Operational Issues screen is only an index into these.
   *
   * @type {Array<OperationalIssue>}
   * @memberof ShipmentDetail
   */
  openIssues?: Array<OperationalIssue>;
  /**
   * Freight-condition flags currently raised on the shipment: missing,
   * short, or damaged. These are facts about the freight the carrier is
   * carrying, so they belong in front of them.
   *
   * The operator and customer flags are deliberately excluded. An
   * operator flag's message is written for the customer, and a customer
   * flag is the customer's own words to us — neither is ours to show a
   * carrier.
   *
   * @type {Array<ShipmentFlag>}
   * @memberof ShipmentDetail
   */
  flags?: Array<ShipmentFlag>;
}

/**
 * Check if a given object implements the ShipmentDetail interface.
 */
export function instanceOfShipmentDetail(
  value: object,
): value is ShipmentDetail {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function ShipmentDetailFromJSON(json: any): ShipmentDetail {
  return ShipmentDetailFromJSONTyped(json, false);
}

export function ShipmentDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDetail {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    state: json["state"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    carrierPickupNumber:
      json["carrierPickupNumber"] == null
        ? undefined
        : json["carrierPickupNumber"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    carrierServiceName:
      json["carrierServiceName"] == null
        ? undefined
        : json["carrierServiceName"],
    pickupBusinessName:
      json["pickupBusinessName"] == null
        ? undefined
        : json["pickupBusinessName"],
    pickup: json["pickup"] == null ? undefined : json["pickup"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    deliveryBusinessName:
      json["deliveryBusinessName"] == null
        ? undefined
        : json["deliveryBusinessName"],
    delivery: json["delivery"] == null ? undefined : json["delivery"],
    deliveryDate:
      json["deliveryDate"] == null ? undefined : json["deliveryDate"],
    commodity: json["commodity"] == null ? undefined : json["commodity"],
    handlingUnits:
      json["handlingUnits"] == null ? undefined : json["handlingUnits"],
    weightLbs: json["weightLbs"] == null ? undefined : json["weightLbs"],
    freightClass:
      json["freightClass"] == null ? undefined : json["freightClass"],
    quotedTransitDays:
      json["quotedTransitDays"] == null ? undefined : json["quotedTransitDays"],
    actualTransitDays:
      json["actualTransitDays"] == null ? undefined : json["actualTransitDays"],
    paidCad: json["paidCad"] == null ? undefined : json["paidCad"],
    bookedAt: json["bookedAt"] == null ? undefined : json["bookedAt"],
    openIssues:
      json["openIssues"] == null
        ? undefined
        : (json["openIssues"] as Array<any>).map(OperationalIssueFromJSON),
    flags:
      json["flags"] == null
        ? undefined
        : (json["flags"] as Array<any>).map(ShipmentFlagFromJSON),
  };
}

export function ShipmentDetailToJSON(json: any): ShipmentDetail {
  return ShipmentDetailToJSONTyped(json, false);
}

export function ShipmentDetailToJSONTyped(
  value?: ShipmentDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    state: value["state"],
    proNumber: value["proNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    carrierPickupNumber: value["carrierPickupNumber"],
    serviceIdentifier: value["serviceIdentifier"],
    carrierServiceName: value["carrierServiceName"],
    pickupBusinessName: value["pickupBusinessName"],
    pickup: value["pickup"],
    pickupDate: value["pickupDate"],
    deliveryBusinessName: value["deliveryBusinessName"],
    delivery: value["delivery"],
    deliveryDate: value["deliveryDate"],
    commodity: value["commodity"],
    handlingUnits: value["handlingUnits"],
    weightLbs: value["weightLbs"],
    freightClass: value["freightClass"],
    quotedTransitDays: value["quotedTransitDays"],
    actualTransitDays: value["actualTransitDays"],
    paidCad: value["paidCad"],
    bookedAt: value["bookedAt"],
    openIssues:
      value["openIssues"] == null
        ? undefined
        : (value["openIssues"] as Array<any>).map(OperationalIssueToJSON),
    flags:
      value["flags"] == null
        ? undefined
        : (value["flags"] as Array<any>).map(ShipmentFlagToJSON),
  };
}
